import get from 'lodash/get'
import styled, { css } from 'styled-components'

import { gridOffsetFrom, gridOffsetTo } from 'bl-common/src/constants/sizes'
import { zIndex } from 'bl-common/src/constants/zIndex'
import { Section } from 'bl-common/src/units/Section/Section'
import { between } from 'bl-common/src/utils/between'
import { media } from 'bl-common/src/utils/media'

import { formatGradient } from '../../../utils/formatters/elements'
import { Related } from '../../Related'

export const Container = styled(({ ...props }) => (
  <Section noHorizontalPadding {...props} />
))`
  ${media.md(css`
    margin-top: ${({ theme }) => theme.spacing[4]};
    margin-bottom: 0;
  `)}
`

export const Frame = styled.div<{
  frameGradientColor1?: string
  frameGradientColor2?: string
  frameGradientDegrees: string
  offsetDirection?: 'right' | 'left'
}>`
  position: relative;
  z-index: ${zIndex.above};
  padding-left: ${between(gridOffsetFrom, gridOffsetTo)};
  padding-right: ${between(gridOffsetFrom, gridOffsetTo)};

  ${({ frameGradientColor1, frameGradientColor2, frameGradientDegrees }) =>
    frameGradientColor1 &&
    frameGradientColor2 &&
    css`
      &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        z-index: ${zIndex.behind};
        background: linear-gradient(
          ${frameGradientDegrees},
          ${frameGradientColor1},
          ${frameGradientColor2}
        );
        right: 0;
        left: 0;
      }
    `}

  ${({ frameGradientColor1, offsetDirection }) =>
    frameGradientColor1 &&
    media.md(css`
      &::after {
        bottom: 25%;
        right: ${
          offsetDirection === 'right'
            ? 0
            : between(gridOffsetFrom, gridOffsetTo)
        };
        left: 0;
      }
    `)}
`

export const RelatedExperiences = ({ relatedExperience }) => {
  const {
    title,
    description,
    textContentSide = 'left',
    frameGradient,
    experienceCards,
  } = relatedExperience.fields

  const gradient = formatGradient(frameGradient)
  return (
    <Container>
      <Frame
        frameGradientColor1={get(gradient, 'color1', 'transparent')}
        frameGradientColor2={get(gradient, 'color2', 'transparent')}
        frameGradientDegrees={get(gradient, 'fields.degrees', '90deg')}
      >
        <Related
          heading={title}
          textContent={description}
          textContentSide={textContentSide}
          cards={experienceCards}
        />
      </Frame>
    </Container>
  )
}
